// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-notification-badge {
  position: relative;
}

ion-menu-button {
  --border-radius: none;
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/menu-button/menu-button.component.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;AACD;;AACA;EACC,qBAAA;AAED","sourcesContent":["app-notification-badge {\r\n\tposition: relative;\r\n}\r\nion-menu-button {\r\n\t--border-radius: none;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
